import { type DebriefStage } from '@momentum/types';
import type {
  DeepDiveState,
  MatchPointSession,
  Turn,
} from '../types/deepDive.types';
import type { EditableFact } from '../../shared/types';

export interface ActiveQuestion {
  index: number;
  answer: string;
}

export interface DeepDiveActiveStep {
  activeMatchPointIndex: number | null;
  activeSession: MatchPointSession | null;
  activeFacts: EditableFact[];
  activeTurn: Turn | null;
  activeQuestion: ActiveQuestion | null;
  isComplete: boolean;
}

export function deriveActiveStep(
  state: DeepDiveState,
  factsByStage: Partial<Record<DebriefStage, EditableFact[]>>
): DeepDiveActiveStep {
  if (state.matchPoints.length === 0) {
    return emptyStep();
  }
  if (state.isComplete) {
    return { ...emptyStep(), isComplete: true };
  }

  const activeIndex = state.matchPoints.findIndex(
    (session) => !session.isCompleted
  );

  if (activeIndex === -1) {
    return { ...emptyStep(), isComplete: true };
  }

  const session = state.matchPoints[activeIndex];
  if (!session) return emptyStep();
  const lastTurn = session.turns[session.turns.length - 1] ?? null;
  const facts = factsByStage[session.stage] ?? [];

  return {
    activeMatchPointIndex: activeIndex,
    activeSession: session,
    activeFacts: facts,
    activeTurn: lastTurn,
    activeQuestion:
      lastTurn?.kind === 'question'
        ? { index: lastTurn.questionIndex, answer: lastTurn.answer }
        : null,
    isComplete: false,
  };
}

function emptyStep(): DeepDiveActiveStep {
  return {
    activeMatchPointIndex: null,
    activeSession: null,
    activeFacts: [],
    activeTurn: null,
    activeQuestion: null,
    isComplete: false,
  };
}
